import axios from "axios";

import * as persistence from "./Persistence";
import { get_request_token } from "../Helpers/utils";
import { SessionActions } from "../services";

const apiUri = window.urlAPI;
const tokenApi = "FDOX";

/* CONFIGURA AXIOS */
let iAxios = axios.create({
  defaultInterceptors: true,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Accept: "*/*",
  },
});

iAxios.defaults.timeout = 30000;
//iAxios.defaults.headers.common['Authorization']
iAxios.interceptors.request.use(function (config) {
  const token = JSON.parse(localStorage.getItem("currentUser"));
  if (token) {
    config.headers["Authorization"] = "Bearer " + token;
  }
  return config;
});
iAxios.interceptors.response.use(
  function (response) {
    // console.log(`${response.config.url}: ${response.config.retry}`);

    return response;
  },
  async function (error) {
    if (error.response.status === 401) {
      // Retry all request excerpt [POST] /api/Login
      if (error.config.url.toLowerCase().indexOf("login") === -1) {
        if (!error.config.retry) {
          error.config.retry = true;

          // Get current access token
          const request_token = get_request_token();
          // console.debug(`Current request token ${request_token}`);

          // Retrieve new access token. Response is true or false
          if (
            request_token &&
            (await SessionActions.login(request_token)) === true
          ) {
            // Retry current request (with the new access token)
            return iAxios.request(error.config);
          }
        } else {
          console.error(
            `No more retries for config: ${JSON.stringify(error.config)}!`
          );
        }
      }

      localStorage.removeItem("currentUser");
      window.location.href = window.urlWebDefault;
    }
    if (
      !error ||
      !error.response ||
      error.response.status !== 401 ||
      error.toString().includes("404")
    ) {
      return Promise.reject(error);
    } else {
      const prevInstance = error.config;
      if (
        prevInstance.headers["Authorization"] === "" ||
        error.toString().includes("404")
      ) {
        prevInstance.headers["Authorization"] = tokenApi;
        return axios(prevInstance);
      } else {
        const prevInstance = error.config;
        if (prevInstance.headers["Authorization"] === "") {
          prevInstance.headers["Authorization"] = tokenApi;
          return axios(prevInstance);
        } else {
          persistence.save("sessionExpired", "true");
        }
      }
    }
  }
);

const config = {
  iAxios,
  apiUri,
};

export default config;
